import { injectable, inject } from 'inversify';
import { CancelCartUseCase } from '../../../domain/usecases/SaleUseCases';
import type { CartRepository } from '../../../domain/repositories';
import { TYPES } from '../../../di/types';

/**
 * Implementation of CancelCartUseCase
 * This contains the business logic for cancelling/clearing cart contents
 */
@injectable()
export class CancelCartUseCaseImpl implements CancelCartUseCase {
  constructor(
    @inject(TYPES.CartRepository) private readonly cartRepository: CartRepository
  ) {}

  async execute(cartId: string): Promise<void> {
    try {
      // Validate input parameters
      this.validateParameters(cartId);

      // Cancel the cart (this will mark it as cancelled in the repository)
      await this.cartRepository.delete(cartId);

      console.log(`✅ Cart cancelled: ${cartId}`);
    } catch (error) {
      console.error('Cancel cart failed:', error);
      throw error;
    }
  }

  private validateParameters(cartId: string): void {
    if (!cartId || cartId.trim().length === 0) {
      throw new Error('Cart ID is required');
    }
  }
} 